import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var PrintIcon = (props, _ref) => {
  var {
    attrs
  } = _ref;
  var _a, _b, _c;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var {
    width,
    height
  } = props;
  var commonAttrs = () => {
    var _a, _b;
    return {
      "fill": "none",
      "stroke": "".concat((_a = attrs["stroke-color"]) !== null && _a !== void 0 ? _a : "#2b5dff"),
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "".concat((_b = attrs["stroke-width"]) !== null && _b !== void 0 ? _b : "1")
    };
  };
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.5 17.5",
    width: "".concat(width),
    height: "".concat(height),
    class: (_a = props.class) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, [h("path", Object.assign(Object.assign({}, commonAttrs()), {
    d: "M3.204 5.672V3.211A2.46 2.46 0 0 1 5.664.75h6.169a2.461 2.461 0 0 1 2.463 2.46h0v2.462"
  })), h("path", Object.assign(Object.assign({}, commonAttrs()), {
    d: "M3.011 13.057h-.137a2.31 2.31 0 0 1-2.124-2.46V8.135a2.311 2.311 0 0 1 2.122-2.461h11.755a2.31 2.31 0 0 1 2.123 2.461v2.46a2.311 2.311 0 0 1-2.123 2.462h-.142"
  })), h("path", Object.assign(Object.assign({}, commonAttrs()), {
    d: "M5.234 10.309h7.033a1.912 1.912 0 0 1 2.028 1.77v2.9a1.911 1.911 0 0 1-2.028 1.77H5.234a1.913 1.913 0 0 1-2.03-1.77v-2.9a1.913 1.913 0 0 1 2.03-1.77Z"
  })), h("path", {
    fill: "".concat((_c = attrs["stroke-color"]) !== null && _c !== void 0 ? _c : "#2b5dff"),
    d: "M3.881 7.859a.677.677 0 1 1-.678-.676.677.677 0 0 1 .678.676Z"
  })]);
};